/** Espelha `AnnouncementReceiptStatus` do backend: o que a pessoa fez com o comunicado. */
export enum AnnouncementReceiptStatus {
  PENDING = 'PENDING',
  SEEN = 'SEEN',
  ACKNOWLEDGED = 'ACKNOWLEDGED',
  DISMISSED = 'DISMISSED',
}

export const ANNOUNCEMENT_RECEIPT_STATUS_DESCRIPTION: Record<AnnouncementReceiptStatus, string> = {
  [AnnouncementReceiptStatus.PENDING]: 'Pendente',
  [AnnouncementReceiptStatus.SEEN]: 'Visto',
  [AnnouncementReceiptStatus.ACKNOWLEDGED]: 'Ciente',
  [AnnouncementReceiptStatus.DISMISSED]: 'Dispensado',
};
